class FormValidator {
    constructor(element, fields, options = null) {
        // Propriétes
        this.form = document.querySelector(element);
        this.fields = fields;
        this.errors = [];
        this.success = [];

        // Options
        this.addFieldsDynamic = options.addFieldsDynamic ?? null;
        this.afterValidationSuccess = options.afterValidationSuccess ?? null;
        this.afterValidationError = options.afterValidationError ?? null;

        // Méthode
        this.bindEvents()
    }

    bindEvents(){
        if(this.form) {
            this.form.addEventListener('submit', event => {
                this.errors = [];
                this.success = [];

                if(this.addFieldsDynamic) {
                    const addtionnalFields = this.addFieldsDynamic.call();
                    this.fields = this.fields.concat(addtionnalFields);
                }

                this.removeMessage(); 
                this.validator(event);
            });
        }
    }

    validator(event) {
        for (let i = 0; i < this.fields.length; i++) {
            let type = this.fields[i][0];
            if(type == 'text') {
                let element = this.fields[i][1];
                let elementError = this.fields[i][2];
                this.validatorNotEmpty(element, elementError);
            } else if(type == 'email') {
                let element = this.fields[i][1];
                let elementError = this.fields[i][2];
                this.validatorEmail(element, elementError);
            } else if(type == 'checkbox') {
                let element = this.fields[i][1];
                let elementError = this.fields[i][2];
                this.validatorCheckbox(element, elementError);
            }
        }
        this.showErrors(event);
        this.showSucces(event);
    }

    removeMessage() {
        this.form.querySelector('.error-1').style.display = 'none';
        this.form.querySelector('.error-2').style.display = 'none';
        this.form.querySelector('.success').style.display = 'none';
    }

    addError(elementError) {
        document.querySelector(elementError).classList.add('error');
        this.errors.push(elementError);
    }

    addSuccess(elementError) {
        document.querySelector(elementError).classList.remove('error');
        this.success.push(elementError);
    }

    showErrors(event) {
        if(this.errors.length > 0) {
            event.preventDefault();
            this.form.querySelector('.error-1').style.display = 'inline-block';
            console.error(this.errors);

            if(this.afterValidationError) {
                this.afterValidationError.call();
            }

            return false;
        }
    }

    showSucces(event) {
        if(this.errors.length == 0) {
            this.removeMessage();

            if(this.afterValidationSuccess) {
                event.preventDefault();
                this.afterValidationSuccess.call();
            } else {
                this.form.querySelector('.success').style.display = 'inline-block';
            }

            return true;
        }
    }

    validatorNotEmpty(element, elementError) {
        let fieldValue = document.querySelector(element).value;
        if(fieldValue == '' || fieldValue == undefined || fieldValue == null) {
            this.addError(elementError);
        } else {
            this.addSuccess(elementError)
        }
    }

    validatorEmail(element, elementError) {
        const regExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let fieldValue = document.querySelector(element).value;
        if(!regExp.test(fieldValue)) {
            this.addError(elementError);
        } else {
            this.addSuccess(elementError)
        }
    }

    validatorCheckbox(element, elementError) {
        const checkbox = document.querySelector(element).checked
        if(checkbox) {
            this.addSuccess(elementError)
        } else {
            this.addError(elementError);
        }
    }

}

export default FormValidator;